import { render, staticRenderFns } from "./LoansCreditsFS.vue?vue&type=template&id=5892f1fb&scoped=true"
import script from "./LoansCreditsFS.vue?vue&type=script&lang=ts"
export * from "./LoansCreditsFS.vue?vue&type=script&lang=ts"
import style0 from "./LoansCreditsFS.vue?vue&type=style&index=0&id=5892f1fb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5892f1fb",
  null
  
)

export default component.exports